import React from "react";
// import style from "./Skeleton.scss";

function SkeletonFilter(props) {
    const { filter: filters } = props;
    const SkeletonOutput = (
        <div className={["tms-skeleton-filter-wrap"].join(" ")}>
            <div className={["tms-skeleton-filter-property-wrap"].join(" ")}>
                {Array.apply(null, Array(filters)).map((_, i) => {
                    return (
                        <div
                            key={i}
                            className={[
                                "tms-skeleton-filter-property",
                                `skeleton-filter-property--${i}`,
                            ].join(" ")}
                        ></div>
                    );
                })}
            </div>
            <div className={["tms-skeleton-filter-button-wrap"].join(" ")}>
                <div className={["tms-skeleton-filter-button"].join(" ")}></div>
                <div
                    className={[
                        "tms-skeleton-filter-button",
                        "tms-skeleton-filter-button-reset",
                    ].join(" ")}
                ></div>
            </div>
        </div>
    );
    return SkeletonOutput;
}

export default SkeletonFilter;
